export enum AuthExceptions {
  USER_NOT_FOUND_EXCEPTION = "UserNotFoundException",
  INVALID_PARAMETER_EXCEPTION = "InvalidParameterException",
  CODE_MISMATCH_EXCEPTION = "CodeMismatchException",
  CODE_EXPIRED_EXCEPTION = "ExpiredCodeException",
  LIMIT_EXCEEDED_EXCEPTION = "LimitExceededException",
  NOT_AUTHORIZED_EXCEPTION = "NotAuthorizedException",
  INVALID_PASSWORD_EXCEPTION = "InvalidPasswordException"
}
